module.exports = __webpack_public_path__ + "static/media/cross_red.e9b28c85.svg";